export default "https://cdn-static.gokick.com/assets/e64f1932100d759e3f947f362e9ecc59e4444740/images/spearmint-flavor.b5ab7d3a919e25f2afa45504ef4550ea.png";